import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from "../../gd-components/base-component/base-component";

import SelectorComponent from '../../gd-components/selector/list/selector.jsx';
import ExistingStatus from './existing-item.jsx';

import ButtonDeprecated from 'core/gd-components/buttons/gd-button/gd-button.tsx';
import ModalV4Header from "../../../app/ui/modal/v4/header/v4-header";

const propTypes = {
    onClickNew: PropTypes.func.isRequired,
    onAddExisting: PropTypes.func.isRequired,
    onAddSuggested: PropTypes.func.isRequired,
    onClickNoAccess: PropTypes.func.isRequired,

    onClick: PropTypes.func,

    params: PropTypes.object.isRequired
};

class CreateExisting extends BaseComponent {

    constructor(props) {
        super(props);

        this._bind('onClickNew', 'onClickNoAccess', 'onExistingStatusSelect', 'onSuggestedStatusSelect',
            'renderExisting', 'renderSuggested', 'closeModal');
    }

    onClickNew() {
        this.props.onClickNew();
    }

    onClickNoAccess() {
        this.props.onClickNoAccess();
    }

    onExistingStatusSelect(id) {
        this.props.onAddExisting(id);
    }

    onSuggestedStatusSelect(id) {
        this.props.onAddSuggested(id);
    }

    closeModal(e) {
        e.stopPropagation();
        gd.modal.hide();
    }

    renderExisting(excludeStatuses, systemStatusAllowed = null) {
        const { organization, project } = this.props.params;
        const options = [];
        const companyId = organization ? organization.id : project.companyId;

        let existingStatuses = _.chain(gd.session.statuses.filter(s=>s.companyId === companyId))
            .filter(m=>!m.isDeleted)
            .orderBy(['systemStatus','color',m=>m.name.toLowerCase()],['asc','asc','asc'])
            .map(s=>s.id)
            .value();

        existingStatuses.map(sId=>{
            if (excludeStatuses.includes(sId)) return;

            const status = gd.session.statuses.get(sId);
            if (systemStatusAllowed && status.systemStatus !== systemStatusAllowed) return;

            options.push({
                value: status.id,
                label: status.name,
                iconObj: status
            })
        });

        const existingContent = existingStatuses.length > 0 ? (
            <SelectorComponent className="select-status"
                               options={options}
                               optionComponent={ExistingStatus}
                               onChange={this.onExistingStatusSelect}/>
        ) : (
            <div className="empty-label">No statuses found</div>
        );

        return (
            <div className="row cf existing-statuses">
                <div className="block-title">Existing</div>
                <div className={Classes("element", {empty: existingStatuses.length === 0})}>
                    {existingContent}
                </div>
                <div className="cf"> </div>
            </div>
        );
    }

    renderSuggested(excludeStatuses, systemStatusAllowed = null) {
        const { organization, project } = this.props.params;
        const options = [];
        const companyId = organization ? organization.id : project.companyId;
        let res;

        // dont' render suggested if you're not manager
        if (!gd.ac.check.company.isManager(companyId)) {
            res = <div className="row cf suggested-statuses"> </div>;
        } else {
            const existingStatuses = gd.session.statuses.filter(s=>s.companyId === companyId);
            const excludedNames = excludeStatuses.map(sId=>gd.session.statuses.get(sId).name);
            gd.const.suggestedStatuses.map(status=>{
                if (excludedNames.includes(status.name)) return;
                if (systemStatusAllowed && status.systemStatus !== systemStatusAllowed) return;

                const existingStatus = _.find(existingStatuses, (s)=> {
                    // if delted suggest again!
                    return !s.isDeleted && gd.utils.compare(s.name,status.name);
                });

                if (existingStatus) return;

                options.push({
                    value: status.id,
                    label: status.name,
                    iconObj: status
                })
            });

            // dont' render suggested if we have nothing to suggest
            if (options.length < 1) {
                return;
            }

            const suggestedContent = (
                <SelectorComponent className="select-status"
                                   options={options}
                                   optionComponent={ExistingStatus}
                                   onChange={this.onSuggestedStatusSelect}/>
            );

            res = (
                <div className="row cf suggested-statuses">
                    <div className="block-title">Suggested</div>
                    <div className={Classes("element", {empty: options.length === 0})}>
                        {suggestedContent}
                    </div>
                    <div className="cf"> </div>
                </div>
            );
        }

        return res;
    }

    render() {
        const { organization, project, systemStatus, alreadyAddedStatuses } = this.props.params;
        let excludeStatuses = alreadyAddedStatuses ? alreadyAddedStatuses : [];

        //if project is defined then exclude all statuses already added to project
        if (project) {
            const { localTemplateId, sharedTemplateId, statuses } = project;
            if (statuses && statuses.length > 0) {
                excludeStatuses = excludeStatuses.concat(statuses);
            } else {
                // vic june 2022 - ne ponimau zachem shared template Id tut.... vot ubei... ego ze nikogda netu...
                const templateId = localTemplateId ? localTemplateId : sharedTemplateId;
                if (templateId && gd.session.templatesList.get(templateId)) {
                    excludeStatuses = excludeStatuses.concat(gd.session.templatesList.get(templateId).statuses)
                }
            }
        }

        const companyId = organization ? organization.id : project.companyId;
        const isManager = gd.ac.check.company.isManager(companyId);
        const newButtonType = isManager ? "blue" : "gray";

        return (
            <div className="v4-container placement-middle add-existing" onClick={this.props.onClick}>

                <ModalV4Header height={60} title="Add Status" onClose={this.closeModal} />

                <div className="gd-form-modal create-existing-status-form main">
                    {this.renderExisting(excludeStatuses, systemStatus)}
                    {this.renderSuggested(excludeStatuses, systemStatus)}

                    <div className="row cf custom-status">

                        <div className="element">
                            <ButtonDeprecated label="+ New Status"
                                              onClick={isManager ? this.onClickNew : this.onClickNoAccess}
                                              type={newButtonType}
                                              size="small"/>
                        </div>
                        <div className="cf"> </div>
                    </div>
                </div>
            </div>

        );
    }
}

CreateExisting.propTypes = propTypes;

module.exports = CreateExisting;